import { useEffect } from 'react';
import { AccountLists, useAccountLists } from '@ltvco/refresh-lib/v1';

export function Lists() {
  const { data: lists, isLoading } = useAccountLists();

  useEffect(() => {
    document.title = 'Report Lists - Bumper';
  }, []);

  return <AccountLists lists={lists || []} isBrandLoading={isLoading} />;
}
